"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function arrayToObject(array) {
    if (!array || array.length === 0) {
        return null;
    }
    return array.reduce(function (o, item) { return ((o[item] = true), o); }, {});
}
exports.default = arrayToObject;
